import { render, staticRenderFns } from "./FiltroActividad.vue?vue&type=template&id=1b5fcbab&"
import script from "./FiltroActividad.vue?vue&type=script&lang=ts&"
export * from "./FiltroActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports